import { createRouter, createWebHistory, NavigationGuard } from 'vue-router';
import { PageTitleSetter, SessionGuard } from '@agyletime/vue-3-common/src/routes/guard';
import { getBasePath } from '@agyletime/vue-3-common/src/plugins/basePath';
import OperationsInsightsPage from '@/pages/OperationsInsights/OperationsInsightsPage.vue';
import OperationsAdministrationPage from '@/pages/OperationsAdministration/OperationsAdministrationPage.vue';
import { AdminNavigationGuard } from '@/pages/OperationsAdministration/utils/navigation';

const basePath = getBasePath();

export const router = createRouter({
    history: createWebHistory(basePath + '/'),
    routes: [
        {
            path: '/operations_insights',
            name: 'OperationsInsights',
            component: OperationsInsightsPage,
            meta: { title: 'Operations Insights' },
        },
        {
            path: '/',
            redirect: '/operations_insights',
        },
        {
            path: '/operations_administration',
            name: 'OperationsAdministration',
            component: OperationsAdministrationPage,
            meta: { title: 'Operations Management Administration' },
            beforeEnter: AdminNavigationGuard,
        },
        {
            path: '/build',
            name: 'BuildInfo',
            meta: { title: 'Build Info' },
            component: {
                template: `
                  <div>
                    <h1>Build Info</h1>
                    <dl class="build-info-list" style="width: 50vw; font-size: 1.2rem">
                      <div v-for="[key, value] in Object.entries(buildInfo)" :key="key"
                           style="border-bottom: 1px dashed whitesmoke; display: flex; flex: 1fr 1fr; justify-content: space-between; margin-bottom: 1rem;">
                        <dt style="font-weight: bold;">{{ key }}</dt>
                        <dd>{{ value }}</dd>
                      </div>
                    </dl>
                  </div>
                `,
                data() {
                    return { buildInfo: __BUILD_INFO__ };
                },
            },
        },
        {
            path: '/:notFound',
            redirect: '/operations_insights',
        },
    ],
});

router.beforeEach(SessionGuard);
router.beforeEach(PageTitleSetter as NavigationGuard);
